export default __webpack_public_path__ + "static/media/forest.fd04cce8.jpg";